import { Component, OnInit } from '@angular/core';
import {
	CustomFormAccessor,
	FormConfig,
} from 'src/shared/form-models/form-cva.component';
import { FormBuilder, NgControl, Validators } from '@angular/forms';
import { map, takeUntil } from 'rxjs/operators';

import { FileEvent } from '../documents.models';
import { NewDocumentRequest } from 'src/shared/api';
import { handleUpload } from '../documents.utility';

export const newDocumentRequestFormConfig: FormConfig<NewDocumentRequest> = {
	parentId: [''],
	title: ['', [Validators.maxLength(100)]],
	fileName: [''],
	description: [''],
	timeStamp: [''],
	attributes: [[]],
	data: [''],
	hideFromCustomer: [''],
	hideFromFieldWorker: [true],
	includeInInvoicing: [''],
};

@Component({
	selector: 'rpshared-add-document',
	templateUrl: './add-document.component.html',
	styleUrls: ['./add-document.component.scss'],
})
export class AddDocumentComponent
	extends CustomFormAccessor<NewDocumentRequest>
	implements OnInit {
	constructor(public ngControl: NgControl, public fb: FormBuilder) {
		super(ngControl, fb, newDocumentRequestFormConfig);
	}

	ngOnInit() {
		this.form
			.get('hideFromCustomer')
			.valueChanges.pipe(takeUntil(this.destroyed))
			.subscribe((hideFromCustomer) => {
				if (hideFromCustomer) {
					this.form.get('includeInInvoicing').setValue(false);
					this.form.get('includeInInvoicing').disable();
				} else {
					this.form.get('includeInInvoicing').enable();
				}
			});
		super.ngOnInit();
	}

	uploadFile(event: FileEvent) {
		handleUpload(event)
			.pipe(
				map((docRequest) => {
					if (!(this.form.value as NewDocumentRequest).title) {
						docRequest.title = docRequest.fileName;
					}
					return docRequest;
				})
			)
			.subscribe((request) => {
				this.form.patchValue(request);
			});
	}

	get hiddenFromCustomers(): boolean {
		return this.form.get('hideFromCustomer').value;
	}
}
